export default __webpack_public_path__ + "static/media/venmo.54ec2721.svg";